import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Configuration } from '@custom-types/Configuration';

// eslint-disable-next-line import/no-cycle
import { RootState } from './store';
import { loggedOut } from './system';

interface Event {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  location: string;
  imageUrl?: string;
}

export interface State {
  info: Event;
  configurations: Configuration;
}

export const initialState: State = {
  info: {
    id: '',
    name: '',
    startDate: '',
    endDate: '',
    location: '',
    imageUrl: undefined,
  },
  configurations: {
    checkOutEnabled: false,
    kioskColor: '',
    kioskModeEnabled: false,
    searchEmailEnabled: false,
    showPeopleGroups: false,
    badgePrintingOnsiteLabelsEnabled: false,
    badgePrintingImage: null,
    idleScreenImage: null,
    onsiteLabelPrintingBadges: [],
  },
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setEventInfo: (state: State, action: PayloadAction<Event>) => {
      state.info = action.payload;
    },
    setConfigurations: (state: State, action: PayloadAction<Configuration>) => {
      state.configurations = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(loggedOut, state => {
      state.info = initialState.info;
      state.configurations = initialState.configurations;
    });
  },
});

export default eventSlice;

export const getEventInfo = (state: RootState) => state[eventSlice.name].info;
export const getEventConfigs = (state: RootState) => state[eventSlice.name].configurations;
export const getCheckOutEnabled = (state: RootState) => getEventConfigs(state).checkOutEnabled;
export const getKioskColor = (state: RootState) => getEventConfigs(state).kioskColor;
export const getKioskModeEnabled = (state: RootState) => getEventConfigs(state).kioskModeEnabled;
export const getSearchEmailEnabled = (state: RootState) =>
  getEventConfigs(state).searchEmailEnabled;
export const getPeopleGroupsVisibility = (state: RootState) =>
  getEventConfigs(state).showPeopleGroups;

export const {
  actions: { setEventInfo, setConfigurations },
  reducer: eventReducer,
} = eventSlice;
